'use client'

import {
     Login as LoginForm
} from "@atomicleads/ext-satellite-form";
import { usePostHog } from 'posthog-js/react'


function LoginFormPage({ searchParams }) {
    const posthog = usePostHog()

    return (
        <div className="login">
            <LoginForm productFocus='extension' posthog={posthog} />
        </div>
    )
}

export default LoginFormPage;
